import React, { useCallback } from 'react';
import styled from 'styled-components';

import type { IShiftOffer } from './types';

import { colors } from '@/styles/colors';
import { OnOffer } from '@/assets/icons';
import { BaseShift, ScheduleOfferModal } from '@/components/agent/my-schedule';

const ShiftOffer = ({
  block,
  blockColor,
  contract,
  showLabelOnVTO,
  modal,
  onClick,
  isDlsBlocked,
  day,
}: IShiftOffer): React.ReactElement => {
  const shiftModal = useCallback(
    (parentRef, ref, handleClose) => (
      <ScheduleOfferModal
        contract={contract}
        blockColor={blockColor}
        block={block}
        isOffered={true}
        parentRef={parentRef as React.MutableRefObject<HTMLDivElement>}
        ref={ref}
        handleClose={handleClose}
      />
    ),
    [block, blockColor, contract],
  );

  return (
    <ShiftContainer
      blockColor={blockColor}
      block={block}
      contract={contract}
      modal={modal ? modal : shiftModal}
      icon={OnOffer}
      className="shift-on-offer"
      onClick={onClick}
      isDlsBlocked={isDlsBlocked}
      day={day}
    >
      {showLabelOnVTO && contract.scheduleNameShort}
    </ShiftContainer>
  );
};

export { ShiftOffer };

const ShiftContainer = styled(BaseShift)`
  color: ${props => colors[props.blockColor]['c800']};
  z-index: 1;
`;
